var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [_c("div", [_vm._v("代采APP更新配置")])]
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c("div", [
                  _c(
                    "div",
                    { staticStyle: { padding: "10px 25px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否强制更新：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  model: {
                                    value: _vm.form.is_update,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "is_update", $$v)
                                    },
                                    expression: "form.is_update"
                                  }
                                },
                                _vm._l(_vm.update_data, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { padding: "10px 25px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "版本号：" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.version,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "version", $$v)
                                  },
                                  expression: "form.version"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { padding: "10px 25px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "下载链接：" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.resData.ref },
                                model: {
                                  value: _vm.form.ref,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ref", $$v)
                                  },
                                  expression: "form.ref"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { padding: "10px 25px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "更新说明：" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 10,
                                  placeholder: _vm.resData.remark
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { padding: "0 25px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.comfresh }
                                },
                                [_vm._v("保存")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17eb3336", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17eb3336","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting/PurchaseAppVersionSetting.vue
// module id = null
// module chunks = 